import { Color } from '../interfaces/product';

export const COLOR_TYPES: Color[] = [
  { name: 'black', hexCode: '#000000' },
  { name: 'white', hexCode: '#ffffff' },
  { name: 'red', hexCode: '#f10f29' },
  { name: 'blue', hexCode: '#3333ff' },
  { name: 'yellow', hexCode: '#fbe43a' },
  { name: 'gray', hexCode: '#8a868f' },
  { name: 'purple', hexCode: '#c9a0ff' },
  { name: 'green', hexCode: '#02dd02' },
];

export const SHIRTS_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
export const PANTS_SIZES = [32, 34, 36, 38, 40];
export const SHOES_SIZES = [36, 37, 38, 39, 40];
